<template>
  <v-card>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" md="7" class="headline mb-1 text--primary">
          {{ resposta.transportadora.pessoa.nome }}
          <px-popover-transportador :transportador="resposta.transportadora"/>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="5"
               class="text-right">
          <v-btn v-if="isAberta" color="primary" link :to="contratacaoPath">
            Contratar
          </v-btn>
        </v-col>
      </v-row>
      <p>
        <v-icon>mdi-domain</v-icon>
        {{ resposta.transportadora.pessoa.cnpj | cnpj }}
      </p>
      <div class="text--primary">
        <v-row dense>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">Valor de frete</span>
            <div>
              {{ resposta.total | currency }}
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">ICMS</span>
            <div>
              <px-imposto :imposto="resposta" tipo="ICMS"/>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">Valor sem ICMS</span>
            <div>
              {{ resposta.valorFrete | currency }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">Prazo de entrega</span>
            <div>
              {{ resposta.prazoEntrega }} dias corridos
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">Forma de pagamento</span>
            <div>
              <px-forma-pagamento :forma-pagamento="resposta.formaPagamento"
                                  :prazo-pagamento="resposta.prazoPagamento"/>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">Válido até</span>
            <div>
              {{ resposta.validade | date | naoInformado }}
            </div>
          </v-col>
        </v-row>
        <v-divider class="mt-3"/>
        <v-row dense class="mt-3">
          <v-col cols="12" sm="6">
            <span class="caption font-weight-bold">Observação</span>
            <div>
              <px-show-large-text :large-text="resposta.observacao"/>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="caption font-weight-bold">Arquivos</span>
            <div v-if="resposta.arquivos.length">
              <px-anexo-chip :files="resposta.arquivos"
                             :download-base-path="downloadPath"/>
            </div>
            <div v-else>
              Nenhum arquivo informado
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';

export default {
  props: {
    resposta: Object,
    cotacao: Object,
  },
  computed: {
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao;
    },
    downloadPath() {
      return `cotacoes-fretes/${this.resposta.cotacaoFrete.id}/respostas/${this.resposta.id}/file`;
    },
    contratacaoPath() {
      return `/cotacoes-fretes/${this.resposta.cotacaoFrete.id}/respostas/${this.resposta.id}/contratar`;
    },
  },
};
</script>
